export default (function () {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-hover-observer/dist/es/utils/noop.js
// module id = 1483
// module chunks = 0